/* app/ui/nav/large */

define(
	'app/ui/nav/large',[
		'jquery',
		'util/core',
		'pubsub'
	],
	function($, Core) {

		var NavLarge;
		var $nav;
		var selectors;
		var classes;

		var navHeight;
		var navPos;
		var topPos;

		var $window;
		var $body;
		var $anchorLinks;
		var $navWithMenus;

		return {
			init: function($elm, selectorList, classList) {
				NavLarge = this;
				$nav = $elm;
				selectors = selectorList;
				classes = classList;

				NavLarge._initElements();
				NavLarge._setSizes();
				NavLarge._initSubscriptions();
				NavLarge._initEvents();
			},

			_setSizes: function() {
				navHeight = $nav.outerHeight();
				navPos = $nav.offset().top;
			},

			_initElements: function () {
				$window = $(window);
				$body = $('body');
				$navWithMenus = $nav.find(selectors.navItemMega);
				$anchorLinks = $('.js-anchor-link');
			},

			// Listen for window resize event (listener bound on all.js)
			_initSubscriptions: function () {
				//$.subscribe('/window/resize', NavLarge._setSizes);
				$.subscribe('/window/scroll', NavLarge._stickyNav);
			},

			_initEvents: function() {

				// Using hover if "touch" device. Some caveats with this as it is really only WebKit devices. See https://github.com/Modernizr/Modernizr/issues/548 and https://github.com/Modernizr/Modernizr/issues/753
				require(['hoverIntent'], function() {
					if ($(selectors.noTouch).length) {
						$navWithMenus.hoverIntent({
							over: NavLarge._toggleMegaMenuHover,
							out: NavLarge._toggleMegaMenuHover,
							interval: 30
						});
					}
				});

				$anchorLinks.on('click', NavLarge._processAnchorClick);

				if ($(selectors.noTouch).length) {
					return;
				}
				this._bindTouchEvents();
			},

			_toggleMegaMenu: function (target, click, event) {
				var $thisTarget = $(target);

				//desktop version, keep the <a> attr when it's an link of megamenu item
				if ($thisTarget.closest(selectors.navItemMega).hasClass('js-megamenu-sub-level')) {
					return;
				}
				if (click === 'click') {
					event.preventDefault();
				}
				
				var $thisNav = $thisTarget.is(selectors.navItemMega) ? $thisTarget : $thisTarget.closest(selectors.navItemMega);
				var $expanded = $nav.find('.' + classes.expanded);

				if (click && click === 'click' && $expanded.find(selectors.megamenuHeading)[0] !== target) {
					$expanded.removeClass(classes.expanded);
				}

				$thisNav.toggleClass(classes.expanded);

			},

			unbind: function () {
				$anchorLinks.off('click', NavLarge._processAnchorClick);
				$navWithMenus.off('click', NavLarge._toggleMegaMenu);
				$navWithMenus.unbind('mouseenter').unbind('mouseleave');
				$navWithMenus.removeProp('hoverIntent_t');
				$navWithMenus.removeProp('hoverIntent_s');
				$.unsubscribe('/window/scroll', NavLarge._stickyNav);
			},

			_toggleMegaMenuHover: function() {
				$.publish('/nav/navToggle');
				NavLarge._toggleMegaMenu(this);
			},

			_toggleMegaMenuClick: function(event) {
				$.publish('/nav/navToggle');
				NavLarge._toggleMegaMenu(this, 'click', event);
			},

			_processAnchorClick: function(event) {
				event.preventDefault();

				var hash = this.href.split('#')[1];
				var $anchor = $('#' + hash);

				if ($anchor.length) {
					Core.scrollToElm($anchor, navHeight -1);
				}
			},

			_bindTouchEvents: function() {
				$navWithMenus.each(function() {
					$(this).find(selectors.megamenuHeading).on('click', NavLarge._toggleMegaMenuClick);
				});
				$('body').on('click', NavLarge._handleBodyClick);
			},

			_handleBodyClick: function(e) {
				var $target = $(e.target);

				if (!$target.closest(selectors.nav).length && $nav.find('.' + classes.expanded).length) {
					$nav.find('.' + classes.expanded).removeClass(classes.expanded);
				}
			},

			_stickyNav: function() {
				var newTopPos = $window.scrollTop();

				if (newTopPos > navPos) {
					$nav.addClass(classes.sticky);
					$body.css('padding-top', navHeight);
				} else {
					$nav.removeClass(classes.sticky);
					$body.css('padding-top', 0);
				}
				topPos = newTopPos;
			}
		};
	}
);
